module.exports = __webpack_public_path__ + "static/media/up.d8c5e468.svg";